import { render, staticRenderFns } from "./dialogalert.vue?vue&type=template&id=18de6d98&"
import script from "./dialogalert.vue?vue&type=script&lang=js&"
export * from "./dialogalert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports